import React, { Component } from "react";
import {
  normalizeLocale,
  normalizeProduct,
  policyCheck,
  sendIsScrollTopToApp,
  throttle,
  validateRegion,
} from "./Util";
import "./Policy.css";
import marked from "marked";
import qs from "qs";
import GlobalPolicyStyle from "./GlobalPolicyStyle";

class Policy extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: "",
    };
  }

  handleScroll = throttle(sendIsScrollTopToApp, 50);

  async getPolicy() {
    const productName = normalizeProduct(this.props.match.params.productName);
    const selectedLocale = normalizeLocale(this.props.match.params.locale);
    const regionParam =
      qs.parse(this.props.location.search.replace("?", "")).region || "";
    const selectedRegion = validateRegion(regionParam);

    const document = await policyCheck(
      productName,
      selectedLocale,
      selectedRegion
    );

    this.fileName = document;
  }

  async componentWillMount() {
    await this.getPolicy();

    const policyPath = require(`./policies/${this.fileName}.md`);

    fetch(policyPath)
      .then((response) => {
        return response.text();
      })
      .then((text) => {
        this.setState({
          value: text,
        });
      });
  }

  componentDidMount() {
    const productName = normalizeProduct(this.props.match.params.productName);

    if (productName !== "wallet_terms") {
      return;
    }

    window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  getRawMarkup() {
    marked.setOptions({ breaks: true });
    return { __html: marked(this.state.value) };
  }

  render() {
    const fileLangauge = this.fileName
      ? this.fileName.split("_").at(-2)
      : normalizeLocale(this.props.match.params.locale);

    return (
      <div>
        <GlobalPolicyStyle language={fileLangauge} />
        <div
          className="rootDiv"
          style={{ lineHeight: "22px" }}
          dangerouslySetInnerHTML={this.getRawMarkup()}
        />
      </div>
    );
  }
}

export default Policy;



// WEBPACK FOOTER //
// ./src/Policy.js